export interface FilterTag {
  name: string;
  columnId: number;
}

export enum DashboardColumns {
  WorkOrder = 1,
  Fault,
  Equipment,
  TestPlan,
  SubmittedBy,
  Status,
  SlipId,
  SubmittedDate,
  Depot
}

import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  ɵExtraLocaleDataIndex,
  Input,
  EventEmitter,
  Output,
  TemplateRef,
} from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { environment } from "src/environments/environment";
import { DatePipe } from "@angular/common";
import { NavigationExtras, Router } from "@angular/router";
import { UserRegionComponent } from "src/app/user-management/components/user-region/user-region.component";
import { UserProfileService } from "src/app/core/http/user-profile.service";
import { DataSharingService } from "src/app/services/data-sharing.service";
import { SearchCriteria } from "src/app/models/searchCriteria";
import { StateService } from "src/app/services/state.service";
import * as XLSX from "xlsx";
import { AuthenticationService } from "src/app/core/authentication/authentication.service";
import { SearchComponent } from '../search/search.component';
import { saveAs } from 'file-saver';
import { base64toBlob } from 'src/app/core/base64ToBlob';
import { take } from "rxjs/operators";
import * as CryptoJS from 'crypto-js';

@Component({
    selector: "app-testslips",
    templateUrl: "./testslips.component.html",
    styleUrls: ["./testslips.component.scss"],
    standalone: false
})
export class TestslipsComponent implements OnInit, AfterViewInit {
  columns: any = [];
  viewTestSlipData: any = [];
  showAdvanced = false;
  lastUpdatedDateTime = new Date();
  modalOpned = false;
  userObject: any;
  userDepotNames: any;
  userDepotId: string;
  selectedOrg: any;
  valueCheck: any = [];
  checkValue: any = [];
  @ViewChild("region", { static: false }) region: UserRegionComponent;
  // @ViewChild("actionButtonTemplate_CM", { static: true })
  // actionButtonTemplateCM: TemplateRef<any>;
  @ViewChild("actionButtonTemplate_CM", { static: true })
  actionButtonTemplate_CM: TemplateRef<any>;
  @ViewChild("actionDateTemplate_CM", { static: true })
  actionDateTemplate_CM: TemplateRef<any>;
  @ViewChild("actionLinkTemplate_CM", { static: true })
  actionLinkTemplate_CM: TemplateRef<any>;
  @ViewChild(SearchComponent) SearchComponent;

  currentUser: UserRegionComponent;
  locationPreference: any;
  navigationnDepot: any;
  countListData: any = [];
  approveValue: any;
  reviewValue: any;
  sentToRetest: any;
  unknownHandovers: any;
  searchFilter: any;
  submittedTagsValue: string;
  submittedId:number;
  tagsValue: boolean = false;
  files: any = [];
  nodatafound: boolean = false;
  excelslipData: any = [];

  pageNumber: number = 1;
  pageSize: number = 10;
  sortColumn = 8;
  sortOrder: string = "DESC";
  trainingApp = false;
  userHasAccess: boolean = false;
  isReadOnly: boolean = false;

  reload = () => window.location.reload();
  @Input() columnRowData = [];
  @Input() showFilterBtn = false;
  @Input() pageLength: number = 10;
  // @Input() searchParams: AdvanceSearch;
  @Input() showFilter = false;
  @Input() filterTags: FilterTag[] = [];
  columnHeader = [];
  tableVariant = "all-smth-view";
  resetTable = false;
  isRowClickable = true;
  filterCriteria = [];
  resetGridOnSearch = false;
  showGrid = false;
  showLoader = false;
  isLoader: boolean = false;
  advSearchQuery: any;
  statusTileFilter: any = null;
  locationSaved: boolean;
  // columnId: null;
  constructor(
    private ds: DataService,
    private datePipe: DatePipe,
    private router: Router,
    private userProfileService: UserProfileService,
    private stateService: StateService,
    private authenticationService: AuthenticationService,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this.userObject = this.userProfileService.getLoggedinUserDetails();
    if (this.userObject) {
      this.init();
    } else {
      this.userProfileService.appUser.subscribe((userObject) => {
        if (userObject) {
          this.userObject = userObject;
        }
      });
    }

    this.isReadOnly = this.userProfileService.getIsReadOnly();
    this.userHasAccess = this.userObject?.userRoles.some(role => role.id === 2);
  }

  ngAfterViewInit() {
    this.getDataCount();
  }

  init() {
    if (
      (this.userProfileService.getIsAdmin() || this.userProfileService.getIsReadOnly()) &&
      this.userProfileService.currentUserRoles.length === 1
    ) {
      this.ds
        .getService(environment.BASEURL + environment.GET_ADMIN_ORG_STRUCTURE)
        .subscribe((res) => {
          this.userDepotNames = res.map((x) => x.sectionManager).join(" & ");
          this.userDepotId = res.map((x) => x.id).toString();
          this.getDepotData();
        });
    } else {
      this.dataSharingService.locationPreference$.subscribe(val => this.locationPreference = val);
    this.userDepotNames = this.locationPreference ? this.locationPreference.userDepotName : this.userObject.smthOrgStructure
        .map((x) => x.sectionManager)
        .join(" & ");
      this.userDepotId = this.locationPreference ? this.locationPreference.userDepotId : this.userObject.smthOrgStructure
        .map((x) => x.id)
        .toString();
      this.getDepotData();
    }
    this.isTrainingApp();
  }

  getDepotData() {
    this.columnHeader = this.getHeadersdata();
    this.stateService.searchCriteriaObserable
      .subscribe((res) => {
        if (res && res.searchData.length > 0) {
          if (res.isAdvanced) this.showAdvanced = true;
          // this.viewTestSlipData = res.searchData;
          this.searchFilter = res.searchFilter;
          this.filterCriteria = res.filterCriteria;
          this.columnHeader = res.columnHeader;
          this.filterTags = res.filterTags;
          // this.getSearchGridData()
            setTimeout(() => {
              this.updateFilterPriorities();
              if(this.showAdvanced){
                this.SearchComponent.submitForm();
              }else{
                this.loadGridData()
              }
            }, 2000);
        } else {
          this.populateGridData();
        }
      })
      .unsubscribe();
  }
  private populateGridData() {
    this.ds.navigationdepotId
      .subscribe((res) => {
        if (res) {
          this.userDepotId = res;
        }
      })
      .unsubscribe();
    this.ds.navigationdepotName
      .subscribe((res) => {
        if (res) {
          this.userDepotNames = res;
        }
      })
      .unsubscribe();
    this.loadGridData();
  }

  refreshGrid() {
    this.pageNumber = 1;
    this.advSearchQuery = null;
    this.resetDashboardFilter();
    this.sortColumn = 8;
    this.sortOrder = "DESC";
    this.getDataCount();
    this.loadGridData();
    this.lastUpdatedDateTime = new Date();
    this.tagsValue = false;
  }

  paginationInfo(event): void {
    this.pageNumber = event.pageNumber;
    this.pageSize = event.pageSize;
    if(this.showAdvanced){
      this.SearchComponent.applyAdvSerarch(this.pageNumber);
    }else if(this.tagsValue){
      this.loadGridData(this.submittedId);
    }
    else{
      this.getSearchGridData();
    }
  }

  checkOrUncheckSelected(event): void {
    console.log("check or uncheck event", event);
  }

  sortedColumnData(data): void {
    const index = this.columnHeader.findIndex(
      (el) => el.filterOn === data.sort.columnId
    );
    if (index > -1) {
      this.columnHeader[index].isAscending = data.sort.isAscending;
      this.columnHeader.forEach((column, i) => {
        if (i === index) {
          column.isSorted = true;
        } else {
          column.isSorted = false;
        }
      });
      this.columnHeader = [...this.columnHeader];
      // this.sortedColumnInfo.emit(data);
      this.sortColumn = data.sort.columnId;
      this.sortOrder = data.sort.isAscending ? "ASC" : "DESC";
      this.getSearchGridData();
    }
  }

  onFilterClick(header): void {
    const searchCriteria = this.filterCriteria.filter(
      (column) => column.columnId !== header.filterOn
    );
    const params = {
      gridColumnId: header.filterOn,
      searchCriteria: searchCriteria,
    };
    this.userDepotId;
    // let ids = "/dashboardFilterTestSlips?depot={{this.userDepotId}}&pageNo=1&pageIndex=4&flag={{header.filterOn}}";
    // let ids = "?depot=" + this.userDepotId + "&flag=" + header.filterOn;
    let ids = `?depot=${this.userDepotId}${this.getFilterValues(8)}&testSlipId=${this.getFilterValues(
      7
    )}&submittedby=${this.getFilterValues(5)}&status=${this.getFilterValues(
      6
    )}&plansExecuted=${this.getFilterValues(4)}&assetId=${this.getFilterValues(
      3
    )}&workorderNo=${this.getFilterValues(1)}&faultNo=${this.getFilterValues(
      2
    )}&flag=${header.filterOn}`;
    this.ds
      .getService(`${environment.BASEURL}${environment.COLUMNFILTER}${ids}`)
      .subscribe(
        (response) => {
          response.forEach(elem =>{
            elem.filterValue = elem.filterValue === '' ? null : elem.filterValue;
          });

          if (header.filterOn == 6) {
            this.dataSharingService.shareFilterList({
              list: this.statusFilter(response),
              columnId: header.filterOn,
              filterData: this.filterCriteria,
            });
          } else {
            const options = response.map((x) => x.filterValue);
            this.dataSharingService.shareFilterList({
              list: options.reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []),
              columnId: header.filterOn,
              filterData: this.filterCriteria,
            });
          }
        },
        (err) => console.error(err),
        () => {
          this.showFilter = true;
        }
      );
  }
  onCloseFilterOverlay(e) {
    this.showFilter = false;
  }

  statusFilter(response) {
    let stausRes = response.map((x) => {
      if (x.filterValue == 1) {
        return "SUBMITTED";
      } else if (x.filterValue == 2) {
        return "APPROVED";
      } else if (x.filterValue == 3) {
        return "IN REVIEW";
      } else if (x.filterValue == 4) {
        return "SENT TO RETEST";
      } else if (x.filterValue == 8) {
        return "HANDOVER PENDING";
      }
    });
    return stausRes;
  }

  onFilterData(data): void {
    const index = this.filterCriteria.findIndex(
      (el) => el.columnId === data.columnId
    );

    if (data.filterValues) {
      if (index > -1) {
        this.filterCriteria[index].filterValues = data.filterValues;
      } else {
        this.filterCriteria.push(data);
        this.setColumnFilteredStatus(data.columnId, true);
        this.updateFilterPriorities();
      }
    } else if (index > -1) {
      this.filterCriteria.splice(index, 1);
      this.setColumnFilteredStatus(data.columnId, false);
      this.updateFilterPriorities();
    }
    this.getSearchGridData();
    this.onCloseFilterOverlay("");
  }

  getQueryFiter() {
    let ids = `?${this.getFilterValues(9)}&testSlipId=${this.getFilterValues(
      7
    )}&submittedbyname=${this.getFilterValues(5)}&status=${this.getFilterValues(
      6
    )}&plansExecuted=${this.getFilterValues(4)}&assetId=${this.getFilterValues(
      3
    )}&workorderNo=${this.getFilterValues(1)}&faultNo=${this.getFilterValues(
      2
    )}${this.getFilterValues(8)}&pagenumber=${this.pageNumber}&pageIndex=${
      this.pageSize
    }&sortColumn=${this.sortFilterId(this.sortColumn)}&sortOrder=${this.sortOrder}`;
    return ids;
  }

  getSearchGridData() {
    this.isLoader = true;
    if (this.resetGridOnSearch) this.showGrid = false;
    let query = this.getQueryFiter();
    this.ds
      .getService(
        `${environment.BASEURL}${environment.FILTERTESTSLIPS}${query}`
      )
      .subscribe(
        (res) => {
          if(res.length > 0){
            this.pageLength = res[0].overallCount;
            this.viewTestSlipData = res;
            // this.getDataCount();
            this.showGrid = true;
          }else {
            this.viewTestSlipData = [];
          }
          this.isLoader = false;
        },
        (err: any) => {
          console.error(err)
          this.isLoader = true;
        },
        () => {
          this.showFilterBtn =
            this.filterCriteria && this.filterCriteria.length > 0;
          this.setAppliedFilters();
          this.resetGridOnSearch = false;
          this.isLoader = false;
        }
      );
  }

  getFilterValues(y) {
    if (this.filterCriteria.filter((x) => x.columnId == y).length > 0) {
      if (y == 6) {
        let statusList = [];
        let list = this.filterCriteria.filter((x) => x.columnId == y)[0]
          ?.filterValues;

        list.includes("SUBMITTED") ? statusList.push("1") : "";
        list.includes("APPROVED") ? statusList.push("2") : "";
        list.includes("IN REVIEW") ? statusList.push("3") : "";
        list.includes("SENT TO RETEST") ? statusList.push("4") : "";
        list.includes("HANDOVER PENDING") ? statusList.push("8") : "";
        return statusList.toString();
      } else if (y == 8) {
        let list = this.filterCriteria
          .filter((x) => x.columnId == y)[0]
          ?.filterValues.split(",");
        return `&submittedFrom=${list[0].trim()}&submittedTo=${list[1].trim()}`;
      } else if (y == 9) {
        return `depotName=${this.filterCriteria
          .filter((x) => x.columnId == y)[0]
          ?.filterValues.replace(/[&\/\\]/g, '%26').split(",").toString()}`;
      } else {
        return this.filterCriteria
          .filter((x) => x.columnId == y)[0]
          ?.filterValues.toString();
      }
    } else if (this.statusTileFilter && y == 6) {
      let statusList = [];
      statusList.push(this.statusTileFilter.statusId.toString())
      return statusList.toString();
    } else if(y == 9) {
      return `depot=${this.userDepotId}`;
    } else return "";
  }

  getData(value): string {
    if (value.status == 1) {
      return "SUBMITTED";
    } else if (value?.status == 2 || value?.status == 5 || value?.status == 6) {
      return "APPROVED";
    } else if (value?.status == 3) {
      return "IN REVIEW";
    } else if (value.status == 4) {
      return "SENT TO RETEST";
    } else if (value.status == 8) {
      return "HANDOVER PENDING";
    }
  }

  setAppliedFilters() {
    let filterTags = [];
    this.filterCriteria.forEach((column) => {
      const filters = column.filterValues.split(",").map((filter) => ({
        name: filter,
        columnId: column.columnId,
      }));
      filterTags = [...filterTags, ...filters];
    });
    if(filterTags.filter((x)=> x.columnId == DashboardColumns.SubmittedDate).length > 0){
      let datefilterArray = JSON.parse(JSON.stringify(filterTags));
      datefilterArray = datefilterArray.filter((x)=> x.columnId == DashboardColumns.SubmittedDate);
      filterTags = filterTags.filter((x)=> x.columnId != DashboardColumns.SubmittedDate);
      let dateTypeIs = datefilterArray[2];
      filterTags.push(dateTypeIs);
    }
    this.filterTags = filterTags;
  }
  getCategoryName(filter: FilterTag): string {
    const column = this.columnHeader.find(
      (column) => column.filterOn === filter.columnId
    );
    if (column) return column.title;
  }

  resetDashboardFilter(): void {
    this.resetAllColumnFilterStatus();
    this.resetTable = true;
    this.resetFilter();
    setTimeout(() => {
      this.resetTable = false;
    }, 20);
  }

  resetFilter(): void {
    this.filterCriteria = [];
    this.statusTileFilter = null;
    this.showFilterBtn = false;
    this.setAppliedFilters();
    this.resetGridOnSearch = false;
  }
  resetAllColumnFilterStatus(): void {
    this.columnHeader.forEach((el) => {
      el.isFilterd = false;
    });
  }

  setColumnFilteredStatus(id: number, status: boolean): void {
    const columnId = this.columnHeader.findIndex(
      (header) => id === header.filterOn
    );
    this.columnHeader[columnId].isFilterd = status;
  }

  updateFilterPriorities() {
    this.filterCriteria.forEach((column, index) => {
      column.priority = index;
    });
  }

  onRemoveFilterTag(filter: FilterTag): void {
    this.pageNumber = 1;
    const i = this.filterCriteria.findIndex(
      (criteria) => criteria.columnId === filter.columnId
    );
    let  newFilterValues;
    if(filter.columnId == 8){
      newFilterValues = "";
    }else{
      const oldFilterValues = this.filterCriteria[i].filterValues.split(",");
      newFilterValues = oldFilterValues
       .filter((value) => value !== filter.name)
       .join(",");
    }

    if (newFilterValues) {
      this.filterCriteria[i].filterValues = newFilterValues;
    } else {
      this.filterCriteria.splice(i, 1);
      this.updateFilterPriorities();
      this.setColumnFilteredStatus(filter.columnId, false);
    }
    this.getSearchGridData();
  }

  selectedRowEvent(data): void {}

  loadGridData(ids?) {
    this.isLoader = true;
    let query = this.getQueryFiter();
    if(ids){
      query = `?depot=${this.userDepotId}&status=${ids}&pagenumber=${this.pageNumber}&pageIndex=${
        this.pageSize}`;
    }else {
      query = this.getQueryFiter();
    }
    this.ds
      .getService(
        `${environment.BASEURL}${environment.FILTERTESTSLIPS}${query}`
      )
      .subscribe((res) => {
        if (res && res.length > 0) {
          this.viewTestSlipData = res;
          console.log(res[0])
          this.pageLength = res[0].overallCount;
          this.getStatusdata(res);
          // this.getDataCount();
        } else {
          this.viewTestSlipData = [];
        }
        this.isLoader = false;
      }, (error)=> {
        this.isLoader = false;
      });
    this.columnHeader = this.getHeadersdata();
  }

  sortFilterId(flag){
    //different values for filters sortflag & filter columns
    switch(flag){
      case 1:{ return 3;break;}
      case 2:{ return 2;break;}
      case 3:{ return 4;break;}
      case 4:{ return 5;break;}
      case 5:{ return 7;break;}
      case 6:{ return 8;break;}
      case 7:{ return 1;break;}
      case 8:{ return 6;break;}
      default: { return 6; break;}
    }
  }

  getHeadersdata() {
    return [
      {
        id: "testSlipId",
        title: "SLIP ID",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.SlipId,
        template: {
          templateContent: this.actionLinkTemplate_CM,
        },
      },
      {
        id: "workorderNo",
        title: "WORK ORDER",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.WorkOrder,
      },
      {
        id: "faultNo",
        title: "FAULT",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.Fault,
      },
      {
        id: "assetId",
        title: "EQUIPMENT",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.Equipment,
      },
      {
        id: "testPlan",
        title: "TEST PLAN",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.TestPlan,
      },
      {
        id: "testDateTime",
        title: "SUBMITTED AT",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.SubmittedDate,
        template: {
          templateContent: this.actionDateTemplate_CM,
        },
      },
      {
        id: "testerName",
        title: "SUBMITTED BY",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.SubmittedBy,
      },
      {
        id: "status",
        title: "STATUS",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.Status,
        template: {
          templateContent: this.actionButtonTemplate_CM,
        },
      },
      {
        id: "depot",
        title: "Depot",
        isSearchable: true,
        isSortable: true,
        isSorted: false,
        isAscending: false,
        filterOn: DashboardColumns.Depot,
      }
    ];
  }
  // actionDateTemplate_CM
  getStatusdata(data) {
    data.map((value) => {
      if (value.status === 1) {
        value.statusValue = "SUBMITTED";
      } else if (value.status === 2) {
        value.statusValue = "APPROVED";
      } else if (value.status === 3) {
        value.statusValue = "IN REVIEW";
      } else if (value.status === 4) {
        value.statusValue = "SENT TO RETEST";
      } else if (value.status === 8) {
        value.statusValue = "HANDOVER PENDING";
      }
    });
  }
  navigateToWorkflowPages(id) {
    const criteria = new SearchCriteria(
      this.showAdvanced,
      this.viewTestSlipData,
      this.searchFilter,
      this.filterCriteria,
      this.filterTags,
      this.columnHeader,
      this.pageNumber,
      this.pageSize
    );
    this.stateService.setSearchCriteria(criteria);
     const encryptedId = CryptoJS.AES.encrypt(JSON.stringify(id), environment.ENCRYPTKEY_DATA).toString();
     const navigationExtras: NavigationExtras = {
      queryParams: {
        testSlipId: encryptedId,
      },
    };
    
    this.router.navigate(["/view-testslips"], navigationExtras);
    // this.ds.getViewService(id);
  }
  getDataCount() {
    this.ds
    .getService(
      `${environment.BASEURL}/dashboardKpiCount?depot=${this.userDepotId}`
    )
    .subscribe((res) => {
      this.approveValue = res[0].submitted;
      this.reviewValue = res[0].inReview;
      this.sentToRetest = res[0].sentToRetest;
      this.unknownHandovers = res[0].unknown
    })
   }

  getClass(e): string {
    return "nr-background-green";
  }

  edit(): void {
    this.open();
    this.tagsValue = false;
  }

  close(event): void {
    this.modalOpned = false;
  }
  open(): void {
    this.modalOpned = true;
    setTimeout(() => {
      this.setRegion();
    }, 1000);
  }
  setRegion() {
    this.selectedOrg = [];
    this.selectedOrg = [
      ...new Set(this.userDepotId.split(",").map((x) => +x)),
    ].sort((a, b) => a - b);
    setTimeout(() => {
      this.region.selectorgOnSelect(this.selectedOrg);
    }, 1000);
  }
  saveRegion() {
    this.userDepotNames = [];
    this.userDepotId = "";
    this.userDepotNames = this.region.checklistSelection.selected
      .map((x) => x.name)
      .join(" & ");
    this.userDepotId = this.region.checklistSelection.selected
      .map((x) => x.id)
      .toString();
      const locationPreference = {
        userDepotName: this.userDepotNames,
        userDepotId:this.userDepotId
      }
      this.dataSharingService.locationPreference.next(locationPreference)
    let query = this.getQueryFiter();
    this.ds
      .getService(
        `${environment.BASEURL}${environment.FILTERTESTSLIPS}${query}`
      )
      .subscribe((res) => {
        this.viewTestSlipData = res;
        if(res.length > 0) {
          this.pageLength = res[0].overallCount;
        }
        this.getStatusdata(res);
        this.getDataCount();
      });

    this.modalOpned = false;
    this.ds.getViewDepotId(this.userDepotId);
    this.ds.getViewDepotName(this.userDepotNames);
  }

  filterGrid(filterData) {
    if (filterData.result && filterData.result.length > 0) {
      this.viewTestSlipData = filterData.result;
      this.pageLength = filterData.result[0].overallCount;
      this.getStatusdata(filterData.result);
      this.searchFilter = filterData.criteria;
      this.advSearchQuery = filterData.query;
      // this.getDataCount();
    } else {
      this.viewTestSlipData = [];
    }
  }

  showAdvancedEvent(params) {
    // visible: boolean, forceRefresh = false
    this.showAdvanced = params.visible;
    if (!this.showAdvanced || params.forceRefesh) {
      this.refreshGrid();
    }
  }

  filterAllList(value) {
    // this.refreshGrid()
    this.tagsValue = true;
    this.submittedId = value;
    switch(value){
      case "1" : 
       this.submittedTagsValue = "Submitted"; 
       break;
      case "3": 
        this.submittedTagsValue = "In Review";
        break;
      case "4":
        this.submittedTagsValue = "Sent To Retest"
        break;
      case "8":
        this.submittedTagsValue = "Handover Pending"
      default:
      //  this.submittedTagsValue = "Submitted"; 
        break;  
    }
    // if (value === "1") {
    //   this.submittedTagsValue = "Submitted";
    // } else if (value === "3") {
    //   this.submittedTagsValue = "In Review";
    //   value = value + ',5,6';
    // } else if(value === "4") {
    //   this.submittedTagsValue = "Sent To Retest"
    // }

    this.resetDashboardFilter();
    this.statusTileFilter = {
      statusId: value,
      filterValue: this.submittedTagsValue
    }
    this.sortColumn = 8;
    this.sortOrder = "DESC";
    this.pageNumber=1;
    this.loadGridData(value)

  }
  exportexcel() {
    this.showLoader = true;
    let query =  this.advSearchQuery ? this.advSearchQuery : this.getQueryFiter();
    this.ds
      .createServiceTextResponseType(environment.BASEURL + environment.FILTERTESTSLIPSEXPORT.replace('{data}',query))
      .pipe(take(1))
      .subscribe((res) => {
        this.showLoader = false;
        saveAs(
          base64toBlob(
            res,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ),
          `Testslipdetails.xlsx`
        );
      });
   }

  isTrainingApp(){
    let trainer = this.userProfileService.getLoggedinUserRoles().includes(7);
    let trainee = this.userProfileService.getLoggedinUserRoles().includes(8);
    this.trainingApp =  (trainer || trainee);
    }

  addOfflineTestslip() {
    this.router.navigate(["/add-testslip"]);
  }
}
